module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('b-container', {
    staticClass: "m-0 p-1",
    attrs: {
      "fluid": ""
    }
  }, [(_vm.status !== 'RUNNING') ? _c('el-tabs', {
    staticClass: "mt-1",
    attrs: {
      "type": "border-card",
      "tab-position": "top"
    }
  }, [_c('el-tab-pane', {
    attrs: {
      "label": "Sample Data"
    }
  }, [_c('b-row', {
    staticClass: "p-0 m-0"
  }, [_c('b-col', {
    staticClass: "d-flex justify-content-end p-0"
  }, [_c('span', {
    staticClass: "d-inline-flex p-1"
  }, [_c('b-form-select', {
    attrs: {
      "id": "per-page-select"
    },
    model: {
      value: (_vm.table.rowsPerPage),
      callback: function($$v) {
        _vm.$set(_vm.table, "rowsPerPage", $$v)
      },
      expression: "table.rowsPerPage"
    }
  }, [_c('b-form-select-option', {
    attrs: {
      "value": 10
    }
  }, [_vm._v("10")]), _vm._v(" "), _c('b-form-select-option', {
    attrs: {
      "value": 20
    }
  }, [_vm._v("20")]), _vm._v(" "), _c('b-form-select-option', {
    attrs: {
      "value": 50
    }
  }, [_vm._v("50")]), _vm._v(" "), _c('b-form-select-option', {
    attrs: {
      "value": 100
    }
  }, [_vm._v("100")])], 1)], 1), _vm._v(" "), _c('span', {
    staticClass: "d-inline-flex p-1"
  }, [_c('b-pagination', {
    attrs: {
      "variant": "outline-secondary",
      "total-rows": _vm.table.totalRows,
      "per-page": _vm.table.rowsPerPage
    },
    model: {
      value: (_vm.table.pageNo),
      callback: function($$v) {
        _vm.$set(_vm.table, "pageNo", $$v)
      },
      expression: "table.pageNo"
    }
  })], 1)])], 1), _vm._v(" "), _c('b-row', [_c('b-col', [(_vm.status === 'SUCCESS') ? _c('b-table', {
    attrs: {
      "head-variant": "light",
      "no-border-collapse": "",
      "bordered": "",
      "striped": "",
      "hover": "",
      "small": "",
      "sticky-header": "",
      "items": _vm.table.data,
      "fields": _vm.table.fields,
      "current-page": _vm.table.pageNo,
      "per-page": _vm.table.rowsPerPage
    }
  }) : _vm._e()], 1)], 1)], 1), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": "Columns"
    }
  }, [_c('b-row', {
    staticClass: "p-0 m-0"
  }, [_c('b-col', {
    staticClass: "d-flex justify-content-end p-0"
  }, [_c('span', {
    staticClass: "d-inline-flex p-1"
  }, [_c('b-form-select', {
    attrs: {
      "id": "per-page-select"
    },
    model: {
      value: (_vm.columns.rowsPerPage),
      callback: function($$v) {
        _vm.$set(_vm.columns, "rowsPerPage", $$v)
      },
      expression: "columns.rowsPerPage"
    }
  }, [_c('b-form-select-option', {
    attrs: {
      "value": 10
    }
  }, [_vm._v("10")]), _vm._v(" "), _c('b-form-select-option', {
    attrs: {
      "value": 20
    }
  }, [_vm._v("20")]), _vm._v(" "), _c('b-form-select-option', {
    attrs: {
      "value": 50
    }
  }, [_vm._v("50")]), _vm._v(" "), _c('b-form-select-option', {
    attrs: {
      "value": 100
    }
  }, [_vm._v("100")])], 1)], 1), _vm._v(" "), _c('span', {
    staticClass: "d-inline-flex p-1"
  }, [_c('b-pagination', {
    attrs: {
      "variant": "outline-secondary",
      "total-rows": _vm.columns.totalRows,
      "per-page": _vm.columns.rowsPerPage
    },
    model: {
      value: (_vm.columns.pageNo),
      callback: function($$v) {
        _vm.$set(_vm.columns, "pageNo", $$v)
      },
      expression: "columns.pageNo"
    }
  })], 1)])], 1), _vm._v(" "), _c('b-row', [_c('b-col', [(_vm.status === 'SUCCESS') ? _c('b-table', {
    attrs: {
      "head-variant": "light",
      "responsive": "",
      "bordered": "",
      "striped": "",
      "hover": "",
      "sticky-header": "",
      "items": _vm.columns.data,
      "fields": _vm.columns.fields,
      "current-page": _vm.columns.pageNo,
      "per-page": _vm.columns.rowsPerPage
    }
  }) : _vm._e()], 1)], 1)], 1), _vm._v(" "), _c('el-tab-pane', {
    staticStyle: {
      "height": "260px",
      "overflow": "auto"
    },
    attrs: {
      "label": "Script"
    }
  }, [_c('div', {
    staticClass: "d-flex"
  }, [_c('a-code-editor', {
    staticClass: "m-0 p-0",
    attrs: {
      "lineNumbers": "",
      "readonly": ""
    },
    model: {
      value: (_vm.createTableScript),
      callback: function($$v) {
        _vm.createTableScript = $$v
      },
      expression: "createTableScript"
    }
  })], 1)])], 1) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0d7c3577","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/TableInfo.vue
// module id = 2137
// module chunks = 1